import { render, staticRenderFns } from "./PortretSlider.vue?vue&type=template&id=b1004038&scoped=true&"
import script from "./PortretSlider.vue?vue&type=script&lang=js&"
export * from "./PortretSlider.vue?vue&type=script&lang=js&"
import style0 from "./PortretSlider.vue?vue&type=style&index=0&id=b1004038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1004038",
  null
  
)

export default component.exports